import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { connect } from 'react-redux';
import { changeIsProfile } from '../../redux/actions';
import store from '../../redux/store';
import { Link } from "react-router-dom";

const mapDispatchToProps = dispatch => {
    return {
        onClick2: isEditProfile => dispatch(changeIsProfile(isEditProfile))
    }
}

export class CustomerCard extends Component {
    constructor(props) {
        super(props);
        this.changeIsEditProfile = this.changeIsEditProfile.bind(this);
    }

    changeIsEditProfile() {

        if (this.props.changeStateOfEdit != undefined) {
            console.log("more is " + this.props.changeStateOfEdit);
            store.dispatch(changeIsProfile(this.props.changeStateOfEdit));
        }
    }

    render() {
        return (
            <Link to={this.props.route}>
                <div className="card card-stats" onClick={this.changeIsEditProfile}>
                    <div className="content clickable">
                        <Row >
                            <Col xs={12} >
                                <div className="icon-big text-center icon-warning text-center">
                                    {this.props.icon}
                                </div>
                            </Col>
                            <Col xs={12} >
                                <div className="text-center">
                                    <p>{this.props.name}</p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Link>
        );
    }
}



const CustomerCardConnect = connect(null, mapDispatchToProps)(CustomerCard);



export default CustomerCardConnect;